import { NgModule } from '@angular/core';

import { GroupByPipe } from './groupBy.pipe';
import { DateFormat } from './dateFormat.pipe';
import { DateTimeFormat } from './dateFormatTime.pipe';
import { TimeFormat } from './timeFormat.pipe';
import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { TruncatePipe } from './truncate.pipe';
import { SortByPipe } from './SortByPipe.pipe';
import { GroupByWithSumPipe } from './groupByWithSum.pipe';

@NgModule({
  declarations: [GroupByPipe, DateFormat, DateTimeFormat, TimeFormat, FilterPipe, SearchPipe, SortByPipe, TruncatePipe, GroupByWithSumPipe],
  imports: [],
  exports: [GroupByPipe, DateFormat, DateTimeFormat, TimeFormat, FilterPipe, SearchPipe, SortByPipe,TruncatePipe, GroupByWithSumPipe]
})
export class PipesModule { }
